import { Outlet, useParams } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import useParamWorkspaceId from '@/hook/useParamWorkspaceId';
import { useMemo } from 'react';
import useConsoleLayoutConfig from '@/hook/useConsoleLayoutConfig';
import { ArrowLeftIcon } from '@radix-ui/react-icons';

const GPUInstanceDetailLayout = () => {
  const { workspaceId } = useParamWorkspaceId();
  const { instanceId } = useParams<{ instanceId: string }>();

  const navItems = useMemo(() => {
    if (!instanceId) return [];
    return [
      {
        href: PATH_PAGE.dashboard.gpuInstance.instances(workspaceId),
        label: 'All Instances',
        strictMatch: true,
        separator: true,
        icon: <ArrowLeftIcon />,
      },
      {
        href: PATH_PAGE.dashboard.gpuInstance.byId(workspaceId, instanceId).overview,
        label: 'Overview',
        strictMatch: true,
      },
    ];
  }, [workspaceId, instanceId]);

  const navbarConfig = useMemo(
    () => ({
      title: `Instance: ${instanceId?.slice(0, 8)}...`,
      navbar: navItems,
    }),
    [instanceId, navItems]
  );

  useConsoleLayoutConfig({
    navConfig: navbarConfig,
  });

  return <Outlet />;
};

export default GPUInstanceDetailLayout;
